import { useEffect, useState } from "react"

export const useHeaderScroll = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollPositionWithModal =
        document.body.style.position === "fixed" ? Math.abs(parseInt(document.body.style.top, 10)) : 0
      const scrollPosition = window.scrollY || scrollPositionWithModal

      setIsScrolled(scrollPosition > 0)
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    handleScroll()

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return isScrolled
}
